<div class="row pt-1">
  <div class="py-1 col-md-12">
    <div class="d-flex">
            <div [ngClass]="
            {'drillDownPickerOpen': showDateDrilldownPicker,
            'drillDownPickerClosed': !showDateDrilldownPicker}">
        @if (periodFrom !== undefined && periodTom !== undefined) {
          <rask-date-drill-down-selector
            id="dateDrillDown"
            [hidden]="!showDateDrilldownPicker"
            [periodFrom]="periodFrom"
            [periodTom]="periodTom"
            dateDepth="VECKA"
            (dateDrilldownPickerToggled)="toggleDateDrilldownPicker()"
            (dateSelected)="onDateSelected($event)">
          </rask-date-drill-down-selector>
        }
        <div class="show-manadsvaljare closed-month-picker" [hidden]="showDateDrilldownPicker">
          <span class="show-text" (click)="toggleDateDrilldownPicker()">
            <i class="far fa-chevron-right"></i>
            <span class="vertical-text">{{ 'JUSTERA_LEVERANSPLAN_VISA_DATUMVALJAREN' | translate }}</span>
          </span>
        </div>
      </div>
            <div [ngClass]="
            {'move-left-open': showDateDrilldownPicker,
             'move-left': !showDateDrilldownPicker}">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>